module.exports = __webpack_public_path__ + "static/media/walls-logo.87cdb121.png";